import { Link } from "react-router-dom";
import { Linkedin, Facebook, BookOpen } from "lucide-react";

const PinterestIcon = ({ className }: { className?: string }) => (
  <svg className={className || "h-5 w-5"} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 0a12 12 0 0 0-4.37 23.17c-.1-.94-.2-2.4.04-3.43l1.47-6.24s-.38-.76-.38-1.87c0-1.75 1.02-3.06 2.28-3.06 1.08 0 1.6.81 1.6 1.78 0 1.08-.69 2.7-1.05 4.2-.3 1.26.64 2.28 1.88 2.28 2.25 0 3.98-2.37 3.98-5.8 0-3.03-2.18-5.15-5.3-5.15-3.6 0-5.72 2.7-5.72 5.5 0 1.1.42 2.26.94 2.9.1.13.12.24.09.37l-.35 1.44c-.06.24-.19.3-.43.18-1.6-.75-2.6-3.08-2.6-4.96 0-4.04 2.93-7.75 8.46-7.75 4.44 0 7.9 3.17 7.9 7.4 0 4.41-2.78 7.96-6.64 7.96-1.3 0-2.52-.67-2.94-1.47l-.8 3.05c-.29 1.1-1.08 2.5-1.6 3.35A12 12 0 1 0 12 0z"/>
  </svg>
);

const navigation = {
  main: [
    { name: "The Book", href: "/book" },
    { name: "Tools & Templates", href: "/tools" },
    { name: "Shop", href: "/shop" },
    { name: "About DN", href: "/author" },
    { name: "Contact", href: "/contact" },
    { name: "Terms", href: "/terms" },
    { name: "Refund Policy", href: "/refund-policy" },
  ],
  social: [
    { name: "LinkedIn", href: "https://www.linkedin.com/in/danielle-n-mccier-7989a781", icon: Linkedin },
    { name: "Facebook", href: "https://www.facebook.com/profile.php?id=61587120383814", icon: Facebook },
    { name: "Pinterest", href: "https://www.pinterest.com/wranglingchaos/", icon: PinterestIcon },
    { name: "Substack", href: "https://daniellenaomi.substack.com/", icon: BookOpen },
  ],
};

export function Footer() {
  return (
    <footer className="border-t border-border bg-secondary text-secondary-foreground">
      <div className="container py-12 md:py-16">
        <div className="grid gap-8 md:grid-cols-3">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary">
                <span className="font-display text-lg font-bold text-primary-foreground">WC</span>
              </div>
              <span className="font-display text-xl font-bold">Wrangling Chaos</span>
            </div>
            <p className="text-sm text-secondary-foreground/70 max-w-xs">
              The No-Fluff Guide to Agency Project Management. Real talk for real project managers.
            </p>
          </div>

          {/* Navigation */}
          <div className="space-y-4">
            <h3 className="font-display font-semibold">Quick Links</h3>
            <ul className="space-y-2">
              {navigation.main.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-sm text-secondary-foreground/70 hover:text-primary transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Social */}
          <div className="space-y-4">
            <h3 className="font-display font-semibold">Stay Connected</h3>
            <p className="text-sm text-secondary-foreground/70">
              Follow along for project management tips, updates, and exclusive content.
            </p>
            <div className="flex gap-4">
              {navigation.social.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-secondary-foreground/50 hover:text-primary transition-colors"
                  aria-label={item.name}
                >
                  <item.icon className="h-5 w-5" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 border-t border-secondary-foreground/10 pt-8 text-center space-y-2">
          <p className="text-sm text-secondary-foreground/50">
            © 2026 Danyl Studios. All rights reserved.
          </p>
          <p className="text-xs text-secondary-foreground/40 max-w-md mx-auto">
            No part of this publication may be reproduced, distributed, or transmitted without prior written permission.
          </p>
        </div>
      </div>
    </footer>
  );
}
